import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=17205332&"
import script from "./StudentForm.vue?vue&type=script&lang=ts&"
export * from "./StudentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports